module.exports = __webpack_public_path__ + "af0e474c51099390fa6ce67178b7cb47.pdf";